export enum MediaVariant {
  VIDEOS = "Videos",
  RINGKAS = "Ringkas",
}

export type Variant = MediaVariant.VIDEOS | MediaVariant.RINGKAS;
